import { render, staticRenderFns } from "./DomainInput.vue?vue&type=template&id=f59218f2"
import script from "./DomainInput.vue?vue&type=script&lang=js"
export * from "./DomainInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports